import React, { Component } from "react";

const BACKSPACE_KEY = 8;
const LEFT_ARROW_KEY = 37;
const UP_ARROW_KEY = 38;
const RIGHT_ARROW_KEY = 39;
const DOWN_ARROW_KEY = 40;
const userAgent = window.navigator.userAgent.toLowerCase();
const ios = /iphone|ipod|ipad/.test( userAgent );


class PINInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false
    }
  }

  inputRef = React.createRef();


  handleBlur(e) {
    this.inputRef.current.blur()
    this.setState({ focused: false });
  }

  handelFocus(e) {
    this.inputRef.current.focus()
    this.setState({ focused: true });
  }

  handleChange(e) {
    const { filterChars } = this.props;
    let value = String(e.target.value);

    if (this.props.forceUppercase) {
      value = value.toUpperCase();
    }

    if (this.props.type === 'number') {
      value = value.replace(/[^\d]/g, '');
    }

    /** Filter Chars */
    value = value.split('').filter(currChar => !filterChars.includes(currChar)).join('');

    let fullValue = value;


    if (this.props.onChange && fullValue) {
      this.props.onChange(fullValue);
    }

  }


  handleKeyDown(e) {
    let value;
    if (this.props.filterKeyCodes.length > 0) {
      this.props.filterKeyCodes.map((item) => {
        if (item === e.keyCode) {
          e.preventDefault();
          return true;
        }
      });
    }
    const { inputType } = this.props;

    switch (e.keyCode) {
      case BACKSPACE_KEY:
        e.preventDefault();
        value = this.props.value.slice(0, -1);
        if (this.props.onChange) {
          this.props.onChange(value);
        }
        break;

      case LEFT_ARROW_KEY:
        e.preventDefault();
        break;

      case RIGHT_ARROW_KEY:
        break;

      case UP_ARROW_KEY:
        e.preventDefault();
        break;

      case DOWN_ARROW_KEY:
        e.preventDefault();
        break;
      default:
        if(inputType === 'number'){
          if (isNaN(e.key)) {
            e.preventDefault();
            break;
          }
        }
    }

    if(this.props.value.length >= this.props.fields){
      e.preventDefault();
      return;
    }
  }

  render() {
    const { type, pattern, showLastTypedValue, value, fields } = this.props;
    let {isValid, focused } = this.state;
    return (
      <div className='pin-input-wrapper' onClick={() => this.handelFocus()}>
        {
          Array.apply(null, Array(fields)).map((_, idx) => {
            const cellFocused = focused && idx === value.length;
            const filled = idx < value.length;
            const lastValue =  (idx === value.length - 1);
            const lastInput =  (fields === value.length);

            return (
              <div
                key={idx}
                className={`pin-input-div ${(cellFocused || (focused && lastInput && lastValue)) ? 'pin-input-div-active' : ''}`}
              >
                {cellFocused && <div className='input-cursor'/> }
                {focused && filled && (type === 'password' && (!showLastTypedValue || !lastValue)) ? "•" : focused && filled ? value.charAt(idx) : type === 'password' && filled ? "•" : value.charAt(idx)}
                {focused && lastInput && lastValue && <div className='input-cursor'/> }
              </div>
            );
          })
        }
        <input
          ref={this.inputRef}
          type={'password'}
          className='pin-input'
          data-id={0}
          value={value}
          min={0}
          max={1}
          autoComplete="off"
          onFocus={(e) => this.handelFocus(e)}
          onBlur={(e) => this.handleBlur(e)}
          onChange={(e) => this.handleChange(e)}
          onKeyDown={(e) => this.handleKeyDown(e)}
          data-valid={isValid}
          pattern={pattern}
          style={{
            fontSize: ios ? 0 : 1,
            opacity: 0,
            textAlign: 'center',
          }}
        />
      </div>
    );
  }
}

PINInput.defaultProps = {
  autoFocus: true,
  isValid: true,
  disabled: false,
  readOnly: false,
  forceUppercase: false,
  showLastTypedValue: false,
  fields: 4,
  value: '',
  inputType: 'text',
  type: 'text',
  filterKeyCodes: [189, 190],
  filterChars: ['-', '.'],
  inputClassName: 'pin-input',
  inputWrapperClassName: 'pin-input-wrapper'
};

export default PINInput;



// WEBPACK FOOTER //
// ./PINInput.js